import React from "react";
import { FormControl, withStyles, TextField } from "@material-ui/core";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button
} from "@material-ui/core";
import moment from "moment";
//import Datetime from "react-datetime";
import InfiniteCalendar from "react-infinite-calendar";
import "react-infinite-calendar/styles.css"; // only needs to be imported once

const styles = theme => ({
  datePicker: {
    width: "100%"
  }
});

class DatePicker extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  state = {
    open: false
  };

  handleChange = event => {
    if (this.props.input.onChange) {
      var date = moment(event).format("YYYY-MM-DD");
      if(this.props.dateChanged){
        this.props.dateChanged(date);
      }
      this.props.input.onChange(date);
    }
  };

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.meta.touched ||
      nextProps.input.value !== this.props.input.value ||
      nextProps.p_value !== this.props.p_value
    ) {
      this.forceUpdate();
    }
  }

  shouldComponentUpdate() {
    return false;
  }

  openDialog() {
    this.setState({ open: true });
    this.forceUpdate();
  }

  closeDialog() {
    this.setState({ open: false });
    this.forceUpdate();
  }

  render() {
    let lValue = new Date();
    let naDate = false;
    if (this.props.input.value) {
      lValue = this.props.input.value;
    }else{
      naDate = true
    }
    let open = this.state.open;
    return (
      <div>
        <FormControl fullWidth>
          <TextField
            onClick={() => this.openDialog()}
            value={naDate ? "Please Select" : lValue}
            label={this.props.label}
            InputProps={{
              readOnly: true
            }}
          />
        </FormControl>
        <Dialog aria-labelledby="form-dialog-title" open={open} onClose={() => this.closeDialog()}>
          <DialogTitle id="form-dialog-title">{"Choose Date"}</DialogTitle>
          <DialogContent>
            <InfiniteCalendar
              width={400}
              height={300}
              selected={lValue}
              onSelect={this.handleChange}
              min={new Date(1900, 0, 1)}
              minDate={new Date(1900, 0, 1)}
              showTodayHelper={true}
              hideYearsOnSelect={false}
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => this.closeDialog()}
              color="primary"
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default withStyles(styles)(DatePicker);



// WEBPACK FOOTER //
// ./src/components/Wrappers/materialUIWrappers/components/DatePicker.js